import data from "../../../configs/data";
import {Button} from "../../../controlElements/Button";
import {ObservableContainer} from "../../../controlElements/ObservableContainer";
import {DeviceDetector} from "../../../DeviceDetector";

export class LowHighNumbersBetsPanel extends ObservableContainer {

    private buttons: Array<Button> = [];

    private readonly LOW_NUMBERS: Array<number> =
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
    private readonly HIGH_NUMBERS: Array<number> =
        [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36];

    constructor(lowNumbersButtonPositionX: number,
                highNumbersButtonPositionX: number,
                evenOddButtonsPositionY: number) {
        super();
        this.createAndAddLowNumbersBetButton(lowNumbersButtonPositionX, evenOddButtonsPositionY);
        this.createAndAddHighNumbersBetButton(highNumbersButtonPositionX, evenOddButtonsPositionY);
    }

    public getButtonPosition(lowNumbers: boolean): PIXI.Point {
        if (lowNumbers) {
            return (this.buttons[0].position as PIXI.Point);
        } else {
            return (this.buttons[1].position as PIXI.Point);
        }
    }

    private onValueChosen(lowNumbersSelected: boolean): void {
        if (lowNumbersSelected) {
            this.callOnClickedSubscribers(lowNumbersSelected, this.LOW_NUMBERS);
        } else {
            this.callOnClickedSubscribers(lowNumbersSelected, this.HIGH_NUMBERS);
        }
    }

    private onHover(lowNumbersSelected: boolean): void {
        if (lowNumbersSelected) {
            this.callOnPointerDownSubscribers(lowNumbersSelected, this.LOW_NUMBERS);
        } else {
            this.callOnPointerDownSubscribers(lowNumbersSelected, this.HIGH_NUMBERS);
        }
    }

    private onHoverOutside(lowNumbersSelected: boolean): void {
        if (lowNumbersSelected) {
            this.callOnPointerUpSubscribers(lowNumbersSelected, this.LOW_NUMBERS);
        } else {
            this.callOnPointerUpSubscribers(lowNumbersSelected, this.HIGH_NUMBERS);
        }
    }

    private createAndAddLowNumbersBetButton(positionX: number, positionY: number): void {
        const button = new Button(data.images.colorEvenLowBaseState, data.images.colorEvenLowHoverDisableState,
            data.images.colorEvenLowHoverDisableState, data.images.colorEvenLowHoverDisableState);

        this.initializeBetButtonBehavior(button, true);

        button.position.x = positionX;
        button.position.y = positionY;
        this.buttons.push(button);
        this.addChild(button);
    }

    private createAndAddHighNumbersBetButton(positionX: number, positionY: number): void {
        const button = new Button(data.images.colorEvenLowBaseState, data.images.colorEvenLowHoverDisableState,
            data.images.colorEvenLowHoverDisableState, data.images.colorEvenLowHoverDisableState);

        this.initializeBetButtonBehavior(button, false);
        button.position.x = positionX;
        button.position.y = positionY;
        this.buttons.push(button);
        this.addChild(button);
    }

    private initializeBetButtonBehavior(button: Button, thisArg: any): void {
        button.subscribeOnClicked(this.onValueChosen.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_DOWN, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_CANCEL, this.onHoverOutside.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OVER, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OUT, this.onHoverOutside.bind(this, thisArg));
        if (DeviceDetector.isMobileOrTabletDevice()) {
            button.on(Button.BUTTON_EVENTS.POINTER_UP, this.onHoverOutside.bind(this, thisArg));
            button.on(Button.BUTTON_EVENTS.POINTER_UP_OUTSIDE, this.onHoverOutside.bind(this, thisArg));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/rouletteBetsPanel/implementations/LowHighNumbersBetsPanel.ts